import type { LogConfig } from '~/types'

export const useVesselSensors = () => {
  const vesselSensors = useState<LogConfig[]>('vesselSensors', () => [])
  const route = useRoute()

  const fetchVesselSensors = async (vesselId: string | string[]) => {
    if (!vesselId) return
    const { data } = await useQueryEngine<LogConfig[]>(`/vessels/${vesselId}/log-configs`)
    if (data.value) {
      vesselSensors.value = data.value
    }
  }

  watch(
    () => route.params.vesselId,
    (vesselId) => {
      if (vesselId) fetchVesselSensors(vesselId)
    },
    { immediate: true }
  )

  return { vesselSensors }
}
